export default "__VITE_ASSET__BtpIQ86a__"